module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col no-pad map-wrapper"
  }, [(_vm.route.data.route) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "layer-control",
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleTrafficLayer()
      }
    }
  }, [_vm._v("Verkehrslage")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [(_vm.route.showSidebar) ? _c('span', [_vm._v("Route ausblenden")]) : _c('span', [_vm._v("Route einlenden")])])]) : _vm._e(), _vm._v(" "), _c('google-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15,
      "options": _vm.mapOptions
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleTrafficLayer()
      }
    }
  }), _vm._v(" "), _c('google-cluster', {
    attrs: {
      "gridSize": undefined,
      "maxZoom": _vm.mapOptions.maxZoom,
      "minimumClusterSize": 3,
      "styles": undefined,
      "zoomOnClick": true
    }
  }, _vm._l((_vm.stations), function(station, i) {
    return _c('google-marker', {
      key: i,
      attrs: {
        "position": station.location,
        "clickable": true,
        "draggable": false,
        "icon": _vm.getMarkerIcon(station.mts_brand)
      },
      on: {
        "click": function($event) {
          _vm.openInfoWindowTemplate(station, station.tid)
        }
      }
    })
  })), _vm._v(" "), (!(Object.keys(_vm.placeMarker.location).length === 0)) ? _c('google-marker', {
    ref: "placeMarker",
    attrs: {
      "position": _vm.placeMarker.location,
      "clickable": false,
      "draggable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "options": {
        maxWidth: 300
      },
      "position": _vm.infoWindow.position,
      "opened": _vm.infoWindow.open
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWindow.open = false
      }
    }
  }, [(_vm.infoWindow.dataLoaded) ? _c('div', [_c('div', {
    class: _vm.infoWindow.template.mts_brand.toLowerCase(),
    attrs: {
      "id": "iw-container"
    }
  }, [_c('div', {
    staticClass: "iw-title"
  }, [_vm._v(_vm._s(_vm.infoWindow.template.tankstelle))]), _vm._v(" "), _c('div', {
    staticClass: "iw-content"
  }, [_c('div', {
    staticClass: "iw-subTitle"
  }, [_vm._v("Kontakt")]), _vm._v(" "), _c('div', {
    staticClass: "iw-address"
  }, [_c('address', [_c('strong', [_vm._v(_vm._s(_vm.infoWindow.template.tankstelle))]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.infoWindow.template.address.street) + " " + _vm._s(_vm.infoWindow.template.address.street_number) + "\n                                "), _c('br'), _vm._v(" " + _vm._s(_vm.infoWindow.template.address.zip) + " " + _vm._s(_vm.infoWindow.template.address.city) + "\n                                "), _c('br'), _vm._v(" "), (_vm.infoWindow.template.contact.phone) ? _c('strong', {
    attrs: {
      "title": "Telefon"
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })]) : _vm._e(), _vm._v(" " + _vm._s(_vm.infoWindow.template.contact.fax) + "\n                                "), _c('br'), _vm._v(" "), (_vm.infoWindow.template.contact.fax) ? _c('strong', {
    attrs: {
      "title": "Fax"
    }
  }, [_c('i', {
    staticClass: "fa fa-fax"
  })]) : _vm._e(), _vm._v(" " + _vm._s(_vm.infoWindow.template.contact.phone) + "\n                                "), _c('br'), _vm._v(" "), (_vm.infoWindow.template.contact.email) ? _c('a', {
    attrs: {
      "href": ("mailto: " + (_vm.infoWindow.template.contact.email))
    }
  }, [_c('strong', {
    attrs: {
      "title": "E-Mail"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" " + _vm._s(_vm.infoWindow.template.contact.email) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "iw-info"
  }, [_c('div', {
    staticClass: "iw-subTitle"
  }, [_vm._v("Zahlarten")]), _vm._v(" "), _vm._l((_vm.infoWindow.template.payment_methodes), function(method) {
    return _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(method.display_name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "iw-subTitle"
  }, [_vm._v("Kraftstoffe")]), _vm._v(" "), _vm._l((_vm.infoWindow.template.fuel), function(fuel) {
    return _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(fuel.display_name))])
  }), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.position) ? _c('button', {
    staticClass: "btn bt-primary",
    on: {
      "click": function($event) {
        _vm.getRoute(_vm.infoWindow.position)
      }
    }
  }, [_vm._v("\n                            Route\n                        ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": (_vm.baseUrl + "/tankstelle.html?--w4_sprintstations-joblist[@package]=w4.sprintstations&--w4_sprintstations-joblist[@controller]=station&--w4_sprintstations-joblist[@action]=show&--w4_sprintstations-joblist[@format]=html&--w4_sprintstations-joblist[station][__identity]=" + (_vm.infoWindow.template.tid))
    }
  }, [_vm._v("Detailseite")])])])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a49cf66","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/gasStationFinder/stationMap.vue
// module id = 104
// module chunks = 0